import { Link, Typography } from "@mui/material";
import React from "react";
import Gene20Box from "../../Gene20Box/Gene20Box";

export default function CreatorLink() {
  return (
    <Gene20Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexWrap="wrap"
      color="light"
      px={1.5}
      marginTop="3"
    >
      <Typography variant="body1" sx={{ fontVariant: "small-caps" }}>
        website created by
      </Typography>
      <Link href="https://wilfredreign.netlify.app" target="_blank">
        <Typography
          variant="body1"
          color="secondary"
          sx={{ fontVariant: "all-small-caps", cursor: "pointer" }}
        >
          &nbsp;@wilfred reign &nbsp;
        </Typography>
      </Link>
    </Gene20Box>
  );
}
